export default {
    /* GET_ORDERS
    ---------------------------------------------------------------
    */
    GET_ORDERS_REQUEST: state => {
        state.ordersLoading = true
    },
    GET_ORDERS_SUCCESS: (state, data) => {
        state.orders = data.results
        state.ordersLoading = false
    },
    GET_ORDERS_FAILURE: state => {
        state.ordersLoading = false
    },
    GET_WMD_DELIVERY_STATUS_NAMES_SUCCESS: (state, data) => {
        state.wmdDeliveryStatusNames = data.results
    },
    SET_ORDERS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_ORDERS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}